// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"353":"contact","594":"about","652":"service","671":"services"}[chunkId] + "." + {"353":"0cc406aa","594":"151f6fd2","652":"e450b972","671":"9f817288"}[chunkId] + ".css";
};